<app-system-message></app-system-message>
@if (showFilters) {
<section
  [ngClass]="theme.getThemeClass()"
  class="card col-6 mx-auto"
  style="margin-top: 5vh"
>
  <article class="card-body mx-auto article col 6">
    <h4 class="card-title mt-0 text-center">
      {{ "customerReport.title" | translate }}
    </h4>
    <form [formGroup]="invoice">
      <label
        >{{ "client" | translate }}&nbsp;<span class="requiredStar"
          >*</span
        ></label
      >
      <div class="input-group col-12">
        <span class="input-group-text" id="basic-addon1"
          ><i class="fa fa-user"></i
        ></span>
        <select formControlName="client_name" class="form-control">
          <option selected hidden></option>
          @for (client of clients; track $index) {
          <option [value]="client.client_id">{{ client.client_name }}</option>
          }
        </select>
      </div>
      <div class="col-12">
        <label class="form-label">{{ "from" | translate }}</label>
        <input
          class="form-control"
          type="datetime-local"
          formControlName="from"
          appEpochDatetimeLocal
        />
      </div>
      <div class="col-12">
        <label class="form-label">{{ "to" | translate }}</label>
        <input
          class="form-control"
          type="datetime-local"
          formControlName="to"
          appEpochDatetimeLocal
        />
      </div>
      <div class="mt-2 d-flex gap-2">
        <button class="btn btn-primary btn-save" (click)="submit()">
          {{ "customerReport.submit" | translate }}
        </button>
      </div>
    </form>
  </article>
</section>
} @if (showStatistics) {
<div class="filter-toggle">
  <button
    class="btn btn-outline-secondary btn-sm"
    type="button"
    (click)="toggleFilters()"
    [attr.aria-pressed]="showFilters"
  >
    <i class="fa fa-filter" aria-hidden="true"></i>
  </button>
  <button
    class="btn btn-outline-success btn-sm"
    type="button"
    (click)="exportCustomerReport()"
    [disabled]="!deviceLogSummaries.length"
  >
    <i class="fa fa-file-excel-o" aria-hidden="true"></i>
    {{ "customerReport.exportButton" | translate }}
  </button>
</div>
}

<!-- Main Container -->
@if (showStatistics) {
<section id="statistics" [ngClass]="theme.getThemeClass()">
  <nav class="page-header">
    <h3>{{ selectedClient }}</h3>
    <p>{{ "customerReport.billingReport" | translate }}</p>
  </nav>

  <ng-container>
    <!-- Device Information heremofo -->
    <article class="summary" id="deviceInfo">
      <h4>{{ "customerReport.clientInformation" | translate }}</h4>
      <table class="info-table">
        <tr>
          <td class="table-header">
            {{ "customerReport.summary.name" | translate }}:
          </td>
          <td>{{ clientInformation?.client_name }}</td>
        </tr>
        <tr>
          <td class="table-header">
            {{ "customerReport.summary.address" | translate }}:
          </td>
          <td>{{ clientInformation?.address }}</td>
        </tr>
        <tr>
          <td class="table-header">
            {{ "customerReport.summary.contactEmail" | translate }}:
          </td>
          <td>{{ clientInformation?.email }}</td>
        </tr>
        <tr>
          <td class="table-header">
            {{ "customerReport.summary.contactPhone" | translate }}:
          </td>
          <td>{{ clientInformation?.phone_number }}</td>
        </tr>
        <tr>
          <td class="table-header">
            {{ "customerReport.summary.numberOfUsers" | translate }}:
          </td>
          <td>{{ users.length }}</td>
        </tr>
        <tr>
          <td class="table-header">
            {{ "customerReport.summary.numberOfDevices" | translate }}:
          </td>
          <td>{{ devices.length }}</td>
        </tr>
        <tr>
          <td class="table-header">
            {{ "customerReport.summary.numberOfBins" | translate }}:
          </td>
          <td>{{ bins.length }}</td>
        </tr>
        <tr>
          <td class="table-header">
            {{ "customerReport.summary.numberOfSubGroups" | translate }}:
          </td>
          <td>{{ subGroups.length }}</td>
        </tr>
        <tr>
          <td class="table-header">
            {{ "customerReport.summary.logVolumeMb" | translate }}:
          </td>
          <td>{{ logRows }}</td>
        </tr>
      </table>
    </article>

    <!-- Table displaying Thing_name, associated bin, log rows, log memory in MB, associated subgroup -->
    <article class="log-summary">
      <h4>{{ "customerReport.deviceLogSummary" | translate }}</h4>
      <table class="info-table">
        <thead>
          <tr>
            <th>{{ "customerReport.table.device" | translate }}</th>
            <th>{{ "customerReport.table.bin" | translate }}</th>
            <th class="text-end">
              {{ "customerReport.table.logs" | translate }}
            </th>
            <th class="text-end">
              {{ "customerReport.table.megabytes" | translate }}
            </th>
            <th>{{ "customerReport.table.subgroup" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @if (deviceLogSummaries.length === 0) {
          <tr>
            <td class="text-center" colspan="5">
              {{ "notEnoughData" | translate }}
            </td>
          </tr>
          } @else { @for (summary of deviceLogSummaries; track
          summary.thingName) {
          <tr>
            <td>{{ summary.thingName }}</td>
            <td>{{ summary.binName }}</td>
            <td class="text-end">{{ summary.logRows | number }}</td>
            <td class="text-end">{{ summary.logSizeMb | number : "1.2-2" }}</td>
            <td>{{ summary.subGroup }}</td>
          </tr>
          } }
        </tbody>
      </table>
    </article>

    <!-- Line chart displaying log rows per device(thing_name) -->
    <article class="chart-box" id="logRowsChart">
      <h4>{{ "customerReport.charts.logRowsPerDevice" | translate }}</h4>
      <app-log-line-chart></app-log-line-chart>
    </article>

    <!-- Vertical Bar Chart Displaying the number of devices per subgroup -->
    <article class="chart-box" id="subGroupChart">
      <h4>{{ "customerReport.charts.devicesPerSubgroup" | translate }}</h4>
      <app-bar-chart></app-bar-chart>
    </article>
  </ng-container>
  <ng-template #noDataTemplate>
    <article>
      <p class="noDataTemplate">{{ "notEnoughData" | translate }}</p>
      <button
        [ngClass]="theme.getThemeClass()"
        class="btn btn-primary btn-block"
      >
        {{ "toPreviousPage" | translate }}
      </button>
    </article>
  </ng-template>
</section>
}
